<template>
  <el-dialog
    title="批量上传"
    :visible.sync="uploadVisible"
    width="30%"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <el-upload
      class="upload-demo"
      drag
      :action="`/${VUE_APP_CONTENT_PATH}/file/uploadExcel.do`"
      :on-change="onChange"
      :before-remove="onRemove"
      :multiple="false"
      :auto-upload="false"
      :limit="1"
      :on-exceed="onExceed"
      ref="upload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div class="el-upload__tip" slot="tip">
        提示：文件大小不超过10M，需解密后上传；支持格式 xls、xlsx!
        <div v-if="errMsgs.length" style="margin: 8px 0; color: red">
          文件内容格式错误：
        </div>
        <div
          v-if="errMsgs.length"
          class="error-tip"
          slot="tip"
          style="color: red"
        >
          <div
            v-for="(v, index) in errMsgs"
            :key="index"
            style="margin-bottom: 8px"
          >
            {{ v }}
          </div>
        </div>
      </div>
    </el-upload>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelModal">取 消</el-button>
      <el-button type="primary" @click="uploadExcelFile" :loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { uploadRecords } from "@/api/popuManual.js";
const VUE_APP_CONTENT_PATH = process.env.VUE_APP_CONTENT_PATH;

export default {
  props: {
    uploadVisible: Boolean,
  },
  data() {
    return {
      VUE_APP_CONTENT_PATH,
      files: null,
      fileName: "",
      errMsgs: [],
      loading: false,
    };
  },
  methods: {
    cancelModal() {
      this.$emit("closeUploadFile");
      this.files = null;
      this.fileName = "";
      this.$refs.upload.clearFiles();
      this.errMsgs = [];
    },

    onChange(file) {
      console.log(file, this.fileName);
      this.files = file.raw;
      this.errMsgs = [];
      const extension = file.raw.name.split(".")[1] === "xls";
      const extension2 = file.raw.name.split(".")[1] === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 5;
      if (!extension && !extension2) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        return;
      }
      this.fileName = file.raw.name;
    },
    onRemove() {
      this.files = null;
      this.fileName = "";
      this.errMsgs = [];
    },
    onExceed() {
      this.errMsgs = [];
      this.$message.warning("仅支持单文件上传");
    },
    async uploadExcelFile() {
      if (this.fileName == "") return this.$message.warning("请选择上传文件");
      let fileFormData = new FormData();
      fileFormData.append("file", this.files, this.fileName); //filename是键，file是值，就是要传的文件，test.zip是要传的文件名
      this.loading = true;

      const { code, msg, data } = await uploadRecords(fileFormData);
      this.loading = false;

      if (code !== "0000") {
        if (msg) this.$message.error(msg);
        if (data && data.length) {
          this.errMsgs = data;
        }
        return;
      }
      this.$notify({
        title: "提示",
        message: "上传成功",
        type: "success",
      });
      this.$emit("closeUploadFile");
      this.files = null;
      this.fileName = "";
      this.$refs.upload.clearFiles();
      this.errMsgs = [];
    },
  },
};
</script>
<style lang="less" scope>
.error-tip {
  max-height: 200px;
  overflow: auto;
}
</style>
